import React from "react"
import { Checkbox, FormControlLabel, SxProps } from "@mui/material"

type CheckboxInputProps = {
  label: string
  sx?: SxProps

  value?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
  onBlur?: () => void
  name?: string
}

export const CheckboxInput = React.forwardRef<HTMLInputElement, CheckboxInputProps>(
  ({ label, sx, value = false, onChange, onBlur, name }, ref) => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            name={name}
            checked={Boolean(value)}
            onChange={(e, checked) => onChange?.(e, checked)}
            onBlur={onBlur}
            inputRef={ref}
          />
        }
        label={label}
        sx={sx}
      />
    )
  }
)
